import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <SEOMeta
        title="关于嫩草影院 - 品牌介绍、用户口碑与联系方式 | 嫩草影院"
        description="了解嫩草影院品牌故事与发展历程，查看真实用户口碑评价，获取联系我们方式。嫩草影院致力于提供最优质的高清在线影视观看服务。"
        keywords="嫩草影院,关于嫩草影院,嫩草影院联系方式,嫩草影院品牌介绍,在线影院"
        canonicalUrl="https://www.nencaoyingyuan.com/about"
      />

      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于嫩草影院',
          url: 'https://www.nencaoyingyuan.com/about',
          description: '了解嫩草影院的品牌故事、用户口碑与联系方式',
        }}
      />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="w-full max-w-[1000px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <header className="mb-10">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
                关于嫩草影院
              </h1>
              <p className="text-sm text-foreground-500 mt-2">
                高清影视，触手可及 —— 了解我们的故事
              </p>
            </header>

            <BrandIntro />

            <Testimonials />

            <ContactSection />
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}